/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import { useHistory } from "react-router-dom";
import { format as formatDate } from "date-fns";

import {
  SBSearchCallbackParams,
  SBDirectFlightsChangeCallbackParams,
  SBTrackExperimentCustomGoalCallbackParams,
  SBTrackExperimentCallbackParams,
  SBState,
  SBCabinClass,
  ANYWHERE_LOCATION
} from "@bookingcom/flights-searchbox";

import { trackMetaExperimentStage } from "../utils/meta-et-tracking";
import useCreateUrl from "./useCreateUrl";

// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useActions, useStore } from "../store";
import { actions as LoaderActions } from "../store/loadingScreen/actions";
import { actions as SearchResultsActions } from "../store/searchResults/actions";
import { actions as SearchResultsBoundsActions } from "../store/searchResultsBounds/actions";
import { actions as searchActions } from "../store/search/actions";
import { actions as flexibleDateMinPriceActions } from "../store/flexibleDateMinPrice/actions";

import useEventTracking from "./useEventTracking";
import useLocaleContext from "./useLocaleContext";
import useGlobalContext from "./useGlobalContext";
import { SEARCH_DATE_FORMAT } from "../store/search/state";
import useUserAgent from "./useUserAgent";
import { actions as TravelPurposeActions } from "../store/travelPurpose/actions";
import { UICityLocation, UITravelPurpose } from "@flights/types";
import { useCallback, useEffect, useMemo } from "react";
import useRouteName from "./useRouteName";
import { isOfMetaOrigin } from "../utils/marketing-url-params";
import useFormatPrice from "./useFormatPrice";
import { flightsSessionStore, isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import flights_web_mdot_sb_multi_select_chip_v2 from "../utils/experiments/funnel/flights_web_mdot_sb_multi_select_chip_v2";
import { ANYWHERE, INFANT_MAX_AGE } from "@flights/constants";
import searchBoxSelectedDates from "../utils/search-box-selected-dates";
import { trackWithDefaultStage, customGoal, stage } from "@flights/et-universal";
import { useDispatch } from "react-redux";
import { actions as searchBoxStateActions } from "../store/searchBoxState/actions";
import { cloneDeep } from "lodash";
import {
  useGetFiltersDraft,
  useSetFiltersDraft
} from "../components/elements/SearchResults/components/boundsFilterHooks";
import { useSplitBoundsCondition } from "../utils/experiments/funnel/flights_split_bounds_us";
import { resetPredictionExperimentCounter } from "../utils/experiments/funnel/flights_web_aa_flexibility_prediction";

const CA_SOURCE_PAGES = {
  home: "flights_index_sb",
  "fly-anywhere": "flights_fly_anywhere_sb",
  searchresults: "flights_search_sb",
  "pb-change-flight": "flights_postbooking_sb",
  "not-found": "flights_404_sb"
};

const useSearchbox = () => {
  const history = useHistory();
  const { locale } = useLocaleContext();
  const { createUrl, enhanceURLSearchParams } = useCreateUrl();
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const loaderActions = useActions(LoaderActions);
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const actions = useActions(searchActions);
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const searchResultsActions = useActions(SearchResultsActions);
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const travelPurposeActions = useActions(TravelPurposeActions);
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const flexibleActions = useActions(flexibleDateMinPriceActions);
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();
  const { supplierFeatures, requestId, apiPrefix, ipCountry } = useGlobalContext();
  const { isMobile } = useUserAgent();
  const trackV2 = useEventTracking("search_box", requestId);
  const routeName = useRouteName();
  const isMeta = isOfMetaOrigin();
  const { formatPrice } = useFormatPrice();
  const dispatch = useDispatch();
  const { isSplitBounds: shouldShowSplitBounds } = useSplitBoundsCondition();

  const searchHandler = (callBackValues: SBSearchCallbackParams) => {
    let { fromAirport, toAirport, params, isDirect, searchState } = callBackValues;

    if (isFeatureRunningClientSide("FLIGHTS_WEB_CAT_PNH_OVERRIDE")) {
      // ? Override PNH to KTI
      // ? Why - https://docs.google.com/document/d/14TwyYViAm_K61TY0R9XEwSiyEQv9s-UOaHx-a6-mF4Q

      if (fromAirport && fromAirport.includes("PNH.CITY")) {
        fromAirport = fromAirport.replace(/PNH\.CITY/g, "KTI.AIRPORT");
      }

      if (toAirport && toAirport.includes("PNH.CITY")) {
        toAirport = toAirport.replace(/PNH\.CITY/g, "KTI.AIRPORT");
      }

      const fromParam = params.get("from");
      if (fromParam && fromParam.includes("PNH.CITY")) {
        params.set("from", fromParam.replace(/PNH\.CITY/g, "KTI.AIRPORT"));
      }

      const toParam = params.get("to");
      if (toParam && toParam.includes("PNH.CITY")) {
        params.set("to", toParam.replace(/PNH\.CITY/g, "KTI.AIRPORT"));
      }
    }

    const { sort } = store.search;
    params.set("sort", sort);

    // bb_flights_prompt_travel_purpose -> maintain state on search click
    params.set("travelPurpose", store.travelPurpose.travelPurpose);

    // @ts-expect-error: Element implicitly has an 'any' type. Fix the issue timely.
    const caSource = CA_SOURCE_PAGES[routeName];
    const caSourceParam = caSource ? `&ca_source=${caSource}` : "";
    const isCountry = toAirport.includes("COUNTRY");
    const isAnywhere = toAirport.includes(ANYWHERE);
    const isEmptyDestination = !toAirport;
    let newSearchURL = "";

    if (isAnywhere) {
      params.set("to", ANYWHERE);
      params.set("toCountryCode", ANYWHERE);
    }

    if (isCountry) {
      const toCountryCode = searchState.searchSegments[0].to[0].code;
      params.set("toCountryCode", toCountryCode);
      params.set("to", `${toCountryCode}.COUNTRY`);
    }

    // history.push does not work when we are doing the same search again
    // refresh the search when user request the same search again
    const windowQuery = new URLSearchParams(window.location.search);
    const areAllParamsAlreadyPresentedInUrl = Array.from(params).every(
      ([key, value]) => windowQuery.get(key) === value
    );
    if (areAllParamsAlreadyPresentedInUrl) {
      window.location.reload();
    }

    if (isAnywhere || isCountry || isEmptyDestination) {
      newSearchURL = `/fly-anywhere/?${params}${caSourceParam}`;
    } else {
      newSearchURL = `/flights/${fromAirport}-${toAirport}/?${params}${caSourceParam}`;
      /* start - flights_split_bounds_us */
      if (shouldShowSplitBounds) {
        newSearchURL = `/flights/${fromAirport}-${toAirport}/outbound/?${params}${caSourceParam}`;
      }
      /* end - flights_split_bounds_us */
    }

    actions.setValueFromSB(searchState);
    isDirect ? actions.resetFiltersButKeep({ stops: 0 }) : actions.resetFilters();

    searchResultsActions.reset();
    /* start - flights_split_bounds_us */
    dispatch(SearchResultsBoundsActions.resetOutbound());
    dispatch(SearchResultsBoundsActions.resetInbound());
    /* end - flights_split_bounds_us */
    flexibleActions.reset();
    loaderActions.show();

    // flights_web_mdot_sb_multi_select_chip_v2 -- start
    // flights_web_ddot_sb_multi_select_chip_v3 -- start
    const isSolo = Number(params.get("adults") || 0) + Number(params.get("children") || 0) === 1;
    const fromCount = (params.get("fromCountry") || "").split(",").filter(Boolean).length;
    const toCount = (params.get("toCountry") || "").split(",").filter(Boolean).length;
    const fromToCount = Math.max(fromCount, toCount);

    if (isMobile) {
      if (fromToCount == 1) flights_web_mdot_sb_multi_select_chip_v2.goals.airport_city_count_1();
      if (fromToCount == 2) flights_web_mdot_sb_multi_select_chip_v2.goals.airport_city_count_2();
      if (fromToCount > 2) flights_web_mdot_sb_multi_select_chip_v2.goals.airport_city_count_3();

      if (isSolo) {
        flights_web_mdot_sb_multi_select_chip_v2.stages.solo();
      } else {
        flights_web_mdot_sb_multi_select_chip_v2.stages.non_solo();
      }
    }
    // flights_web_ddot_sb_multi_select_chip_v3 -- end
    // flights_web_mdot_sb_multi_select_chip_v2 -- end

    flightsSessionStore?.set?.("flights_web_sr_filter_top_filters_checkbox", false);

    /* start - flights_web_aa_flexibility_prediction */
    resetPredictionExperimentCounter();
    /* end - flights_web_aa_flexibility_prediction */

    if (!!apiPrefix) {
      window.location.assign(apiPrefix + createUrl(newSearchURL));
    } else {
      history.push(createUrl(newSearchURL));
    }
  };

  const filtersDraftWithBounds = useGetFiltersDraft();
  const setFiltersDraft = useSetFiltersDraft();

  const onDirectFlightsChangeHandler = (callbackParams: SBDirectFlightsChangeCallbackParams) => {
    const { isDirect, params } = callbackParams;
    const stopsFilterFromSB = isDirect ? 0 : undefined;

    setFiltersDraft({
      ...filtersDraftWithBounds,
      stops: stopsFilterFromSB
    });

    enhanceURLSearchParams(params);
  };

  const onGetSBExperimentVariant = (name: string, defaultStageNo: number) => {
    return trackWithDefaultStage(name, defaultStageNo);
  };

  const onTrackSBExperiment = (callbackParams: SBTrackExperimentCallbackParams) => {
    const { name, stage: stageNo } = callbackParams;
    stage(name, stageNo);
  };

  const onTrackSBMetaExperimentStage = (callbackParams: SBTrackExperimentCallbackParams) => {
    const { name, stage } = callbackParams;
    trackMetaExperimentStage(name, stage);
  };

  const onTrackSBExperimentCustomGoal = (callbackParams: SBTrackExperimentCustomGoalCallbackParams) => {
    const { name, customGoal: goalNo } = callbackParams;
    customGoal(name, goalNo);
  };

  const onTrackSBExperimentStage = (callbackParams: SBTrackExperimentCallbackParams) => {
    const { name, stage: stageNo } = callbackParams;
    stage(name, stageNo);
  };

  const search = store.search;
  const stops = filtersDraftWithBounds.stops;

  const { searchSegments } = search;
  const initialSearchSegments = cloneDeep(searchSegments);

  if (initialSearchSegments && initialSearchSegments[0]) {
    const currSegment = initialSearchSegments[0];
    if (currSegment.departureDate === undefined && currSegment.returnDate === undefined) {
      const { startDate, endDate } = searchBoxSelectedDates();
      if (startDate) initialSearchSegments[0].departureDate = formatDate(startDate, SEARCH_DATE_FORMAT);
      if (endDate) initialSearchSegments[0].returnDate = formatDate(endDate, SEARCH_DATE_FORMAT);
    }

    if (routeName === "fly-anywhere" && currSegment.to.length === 0) {
      currSegment.to[0] = ANYWHERE_LOCATION as UICityLocation;
    }
  }

  const searchboxInitValue: SBState = useMemo(
    () => ({
      type: search.type,
      searchSegments: initialSearchSegments,
      adults: search.adults,
      children: search.children,
      /*eslint-disable-next-line flights/no-unassigned-todo-comments*/
      // TODO: extend the SBCabinClass type with missing keys
      cabinClass: search.cabinClass as SBCabinClass,
      isDirect: search.isDirect
    }),
    [search.type, search.adults, search.children, search.cabinClass, search.isDirect, initialSearchSegments]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const travelPurpose = (urlParams.get("travelPurpose") || "leisure") as UITravelPurpose;
    if (travelPurpose === store?.travelPurpose?.travelPurpose) return;
    setTimeout(() => travelPurposeActions.setTravelPurpose(travelPurpose), 0);
  }, [travelPurposeActions, store]);

  // bb_flights_prompt_travel_purpose
  const onTravelPurposeChange = (value: UITravelPurpose) => {
    const urlParams = new URLSearchParams(location.search);
    urlParams.set("travelPurpose", value);
    // use window history instead of react to prevent rerender
    window.history.replaceState(null, "", `${location.pathname}?${urlParams.toString()}`);
    travelPurposeActions.setTravelPurpose(value);
  };

  useEffect(() => {
    if (isMobile) {
      if (isMeta) {
        flights_web_mdot_sb_multi_select_chip_v2.stages.meta();
      } else {
        flights_web_mdot_sb_multi_select_chip_v2.stages.direct();
      }
    }
  }, [isMobile, routeName, isMeta]);

  const multiSelectVariant = useMemo(() => {
    if (isMobile && !!flights_web_mdot_sb_multi_select_chip_v2.trackWithDefaultStage()) {
      return 2;
    }

    if (!isMobile) {
      return 3;
    }

    return 0;
  }, [isMobile]);

  const onChange = useCallback((params: SBState) => dispatch(searchBoxStateActions.set(params)), [dispatch]);

  return {
    onSearch: searchHandler,
    onChange,
    onDirectFlightsChange: onDirectFlightsChangeHandler,
    initialValue: searchboxInitValue,
    directFlightsFilterApplied: stops === 0,
    track: () => {},
    trackV2,
    onGetSBExperimentVariant,
    onTrackSBExperiment,
    onTrackSBExperimentCustomGoal,
    onTrackSBExperimentStage,
    onTrackSBMetaExperimentStage,
    dateFNSLocale: locale,
    isMultiStopEnabled: supplierFeatures?.includes("SHOW_MULTI_STOP") || false,
    isSearchResults: routeName.includes("searchresults"),
    infantMaxAge: INFANT_MAX_AGE,
    priceFormatter: formatPrice,
    searchAutoCompleteBaseURL: !!apiPrefix ? { url: apiPrefix, accessToken: "" } : undefined,
    isA11yEnabled: false,
    // bb_flights_prompt_travel_purpose
    travelPurpose: store.travelPurpose?.travelPurpose,
    onTravelPurposeChange: onTravelPurposeChange,
    isShowTravelPurposeCheckbox: false,
    trackLandingGoal: routeName === "home", //prop to track recommendation platform custom goal in the searchbox
    isMobile,
    isMeta,
    ipCountry,
    multiSelectName: isMobile ? "flights_web_mdot_sb_multi_select_chip_v2" : "flights_web_ddot_sb_multi_select_chip_v3",
    multiSelectVariant,
    config: {
      hideMultiCityEmptyInputs: routeName.includes("searchresults")
    },
    fixInputSpacing: false
  };
};

export default useSearchbox;
